<template>
    <div>
        <div class="d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="this.isMobile" name="arrow-left" class="c24" v-on:click="this.close"/>
            <h4 class="fsp20 lh28 neue mb-0" :class="{ 'flex-grow-1 mr24 text-center': this.isMobile }">
                {{ this.content.title || this.$t('components.service.modal.ConfirmCode.1') }}
            </h4>
            <Icon v-if="!this.isMobile" name="close" class="close-icon" @click="this.close"/>
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !this.isMobile }">
            <div class="mb24">
                <label class="fsp14 lh20 neue-roman mb8">
                    {{ this.content.label || this.$t('components.service.modal.ConfirmCode.2') }}
                </label>
                <InputSimple
                    type="text"
                    icon="lock"
                    autofocus
                    :autocomplete="'off'"
                    id="confirm_code"
                    @updateParentState="this.updateState"
                    @onEnter="this.submit"
                />
            </div>
            <div class="d-flex" :class="{ 'position-fixed bottom-0 start-0 end-0 bg-white border-t px24 py16': this.isMobile }">
                <Button :name="$t('components.service.modal.ConfirmCode.3')" class="h48 equal-width mr16" :disabled="!this.code" type="btn-warning" v-on:click="this.submit"/>
                <Button :name="$t('components.service.modal.ConfirmCode.4')" class="h48 equal-width" type="btn-outline-grey" v-on:click="this.close"/>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Icon from '@/components/icons/Icon';
import InputSimple from '@/components/service/InputSimple';

export default {
    components: { Button, Icon, InputSimple },
    props: { close: [Function] },
    data() {
        return {
            code: false,
            content: this.$store.state.modal.content,
        };
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        updateState(state) {
            this.code = state.value;
        },
        submit() {
            if (!this.code) return;
            const code = this.code;
            const callback = this.$store.state.modal.content.callback;
            this.$store.commit('MODAL', { action: false, type: false, content: false });
            this.$store.commit('DARK_WRAPPER', false);
            callback(code);
        }
    },
}
</script>
